import { Outlet } from "react-router-dom";

export default function OrdersPage() {
  return <Outlet />;
}
